(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHTOverlay() {
    const overlay = document.querySelector('[data-ht-overlay]');
    if (!overlay) return;

    // Prevent double-init (Shopify editor reloads sections)
    if (overlay.dataset.htInit === "1") return;
    overlay.dataset.htInit = "1";

    const hideBtn = overlay.querySelector('[data-ht-hide]');
    const labelEl = overlay.querySelector('[data-ht-label]');
    const valueEl = overlay.querySelector('[data-ht-value]');
    const titleEl = overlay.querySelector('.ht-overlay__title');
    const blocks  = Array.from(overlay.querySelectorAll('[data-ht-block]'));

    if (!labelEl || !valueEl) {
      console.warn("HT Overlay: missing data-ht-label or data-ht-value");
      return;
    }

    // ✅ Launch time (California / PT). Jan 1 is PST (-08:00).
    const tSite = new Date('2026-01-01T13:02:00-08:00').getTime();

    // ✅ Fixed start so everyone sees blocks fill as days pass
    const tBuildStart = new Date('2025-12-18T00:00:00-08:00').getTime();

    overlay.hidden = false;

    // Remove the word "COUNTDOWN" (label stays blank)
    labelEl.textContent = "";

    let isScramblingNumbers = false;
    let intervalId = null;

    function fmt(ms){
      const s = Math.max(0, Math.floor(ms/1000));
      const d = Math.floor(s/86400);
      const h = Math.floor((s%86400)/3600);
      const m = Math.floor((s%3600)/60);
      const ss = s%60;
      return `${d}D ${String(h).padStart(2,'0')}H ${String(m).padStart(2,'0')}M ${String(ss).padStart(2,'0')}S`;
    }

    function getCountdownText(){
      const now = Date.now();
      return (now < tSite) ? fmt(tSite - now) : '00D 00H 00M 00S';
    }

    function setBlocks(filledCount){
      if (!blocks.length) return;

      for (const b of blocks) b.classList.remove('is-filled','is-cursor');

      for (let i = 0; i < filledCount && i < blocks.length; i++){
        blocks[i].classList.add('is-filled');
      }

      if (filledCount < blocks.length) {
        const cursorIndex = Math.min(filledCount, blocks.length - 1);
        blocks[cursorIndex].classList.add('is-cursor');
      }
    }

    function tick(){
      if (overlay.hidden) return;

      // Update the number line (unless scrambling right now)
      if (!isScramblingNumbers) {
        valueEl.textContent = getCountdownText();
      }

      // Progress → blocks fill over time
      const now = Date.now();
      const denom = Math.max(1, (tSite - tBuildStart));
      const prog  = Math.min(1, Math.max(0, (now - tBuildStart) / denom));

      const total = blocks.length || 24;
      const naturalFilled = Math.floor(prog * total);
      const filled = Math.min(total, Math.max(3, naturalFilled)); // 3 solid min

      if (prog >= 0.999 || now >= tSite) setBlocks(total);
      else setBlocks(filled);
    }

    function attachScramble(el, getFinalText, { onStart, onEnd, runOnLoad } = {}) {
      if (!el || reduceMotion) return;

      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let running = false;

      function run() {
        if (running || overlay.hidden) return;
        running = true;
        onStart?.();

        const finalText = (typeof getFinalText === "function") ? getFinalText() : el.textContent;
        const original = finalText;
        const len = original.length;

        let frame = 0;
        const maxFrames = Math.max(10, len);
        const speed = 22;

        const t = setInterval(() => {
          const out = original.split("").map((c, i) => {
            if (c === " ") return " ";
            if (i < frame) return c;
            return chars[Math.floor(Math.random() * chars.length)];
          }).join("");

          el.textContent = out;

          frame++;
          if (frame > maxFrames) {
            clearInterval(t);
            el.textContent = original;
            running = false;
            onEnd?.();
          }
        }, speed);
      }

      el.addEventListener("mouseenter", run);
      el.addEventListener("focus", run);

      if (runOnLoad) {
        // small delay so the UI paints + countdown text is set first
        setTimeout(run, 250);
      }
    }

    // Initial tick so the countdown has real numbers before first scramble
    tick();

    // ✅ Scramble headline: hover + initial load (gold while scrambling)
    attachScramble(titleEl, () => titleEl.textContent, {
      onStart: () => titleEl.classList.add('ht-scrambling'),
      onEnd:   () => titleEl.classList.remove('ht-scrambling'),
      runOnLoad: true
    });

    // ✅ Scramble numbers: hover + initial load (gold while scrambling)
    attachScramble(valueEl, () => getCountdownText(), {
      onStart: () => {
        isScramblingNumbers = true;
        valueEl.classList.add('ht-scrambling');
      },
      onEnd: () => {
        isScramblingNumbers = false;
        valueEl.classList.remove('ht-scrambling');
        // snap back to accurate time immediately after scramble
        valueEl.textContent = getCountdownText();
      },
      runOnLoad: true
    });

    // ✅ Hide button closes overlay reliably
    hideBtn?.addEventListener('click', () => {
      overlay.hidden = true;
      overlay.setAttribute('hidden','');
      overlay.style.display = 'none';
      if (intervalId) clearInterval(intervalId);
    });

    intervalId = setInterval(tick, 250);
  }

  // Normal load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHTOverlay);
  } else {
    initHTOverlay();
  }

  // Shopify theme editor reloads sections
  document.addEventListener("shopify:section:load", initHTOverlay);
})();
